export default function getResource(label, vars = []) {
    const resources = {
        viewAll: 'View all',
        title: 'Points Activity',
        noPoints: 'Your points activity will appear here.',
        doNotSeePoints: 'Don’t see your points yet? Your activity will update within 24 hours.',
        errorLoadingPoints: 'We couldn\'t load your points activity right now. Please try again later.'
    };
    return resources[label];
}
